import React from 'react'
import DropdownField from 'core/components/validatedForm/DropdownField'
import CloudProviderRegionPicklist from 'k8s/components/common/CloudProviderRegionPicklist'
import { CloudProviders } from 'app/plugins/infrastructure/components/cloudProviders/model'

const CloudProviderRegionField = ({
  cloudProviderType,
  onChange,
  values,
  wizardContext,
  disabled,
  required = true,
}: Props) => (
  <DropdownField
    id="region"
    label="Region"
    DropdownComponent={CloudProviderRegionPicklist}
    type={cloudProviderType}
    cloudProviderId={values.cloudProviderId}
    onChange={onChange}
    disabled={disabled === undefined ? !values.cloudProviderId : disabled}
    required={required}
    value={wizardContext.region}
    enableSearch
  />
)

interface Props {
  cloudProviderType: CloudProviders
  onChange: (value) => void
  values: any
  wizardContext: any
  disabled?: boolean
  required?: boolean
}

export default CloudProviderRegionField
